import QuestionLabel from './QuestionLabel';
import React from 'react';
import Linkify from '../../Linkify.jsx';
import SafeHtml from '../../SafeHtml.jsx';
import { FormPart, optionAttributes, part } from '~/lib/FormCssApi';

const AgreeToTermsQuestion = ({ value, label, setValue, settings, id }) => {
    let url = settings?.url || '';
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
        // This also helps avoid javascript:// links
        url = `https://${url}`;
    }

    return (
        <div>
            <QuestionLabel label={label} settings={settings} />
            <div {...part(FormPart.DESCRIPTION)} className="flex flex-wrap">
                <SafeHtml html={settings?.description} />
                {!!settings?.url && (
                    <a href={url} className="ml-2" target="_blank">
                        {settings?.urlLabel || 'View Terms'}
                    </a>
                )}
            </div>
            <label
                {...optionAttributes({
                    value: 'yes',
                    isSelected: value === 'yes',
                })}
                className="block mt-1"
            >
                <input
                    {...part(FormPart.OPTION_INPUT)}
                    className="mr-2"
                    type="checkbox"
                    name={id}
                    value="yes"
                    checked={value === 'yes'}
                    onChange={e =>
                        setValue(e.target.checked ? e.target.value : null)
                    }
                />
                <span {...part(FormPart.OPTION_LABEL)}>
                    {!!settings?.agreeLabel ? (
                        <Linkify>{settings?.agreeLabel}</Linkify>
                    ) : (
                        'I agree'
                    )}
                </span>
            </label>
        </div>
    );
};

export default AgreeToTermsQuestion;
